function reportMobile() {
	$('html').addClass('mobile');
}
function mobileUAtest() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
		 reportMobile();
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        reportMobile();
		return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		 reportMobile();
        return "iOS";
    }

    return "unknown";
}
$( document ).ready(function() {
	mobileUAtest();
});


// detect if mobile/desktop: -- requires: '.navbar-toggle'
function isMobile() {
	if (  $('.navbar-toggle:visible').length ) {
		var mobile = 1;
		var desktop = 0;
		$( document ).trigger( "mobileActivated" );
	}
	else { // note: assumes there IS a '.navbar-toggle' !
		var mobile = 0;
		var desktop = 1;
		$( document ).trigger( "desktopActivated" );
	}
}